(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
    
    
  }
           customElements.get("sticky-header") || customElements.define("sticky-header", StickyHeader), document.addEventListener("DOMContentLoaded", function() {
                    const searchArray = ["Rings", "Earrings", "Necklaces", "Bracelets", "Mangalsutra", "Anklets", "Watch"],
                        staticPlaceholder = "Search for ";
                    let dynamicPlaceholder = "",
                        searchPlaceholderIndex = 0,
                        offset = 0;
                    const len = searchArray.length;
                    let forwards = !0,
                        skipCount = 0;
                    const skipDelay = 15,
                        speed = 100,
                        inputs = document.querySelectorAll(".field .search__input");

                    function type() {
                        const currentText = searchArray[searchPlaceholderIndex];
                        forwards ? offset >= currentText.length && (skipCount++, skipCount === skipDelay && (forwards = !1, skipCount = 0)) : offset === 0 && (forwards = !0, searchPlaceholderIndex++, searchPlaceholderIndex >= len && (searchPlaceholderIndex = 0)), dynamicPlaceholder = currentText.substring(0, offset), skipCount === 0 && (forwards ? offset++ : offset--), inputs.forEach(el => {
                            el.setAttribute("placeholder", staticPlaceholder + dynamicPlaceholder)
                        }), requestAnimationFrame(() => {
                            setTimeout(type, speed)
                        })
                    }
                    type()
                }),
                function() {
                    "use strict";
                    document.addEventListener("click", function(e) {
                        if (!e.target.closest(".field.desktop")) return;
                        const stickyHeader = document.querySelector("sticky-header"),
                            searchDrawer = document.querySelector(".header__search details");
                        stickyHeader && typeof stickyHeader.forceReveal == "function" && stickyHeader.forceReveal(), requestAnimationFrame(() => {
                            if (!searchDrawer) return;
                            searchDrawer.setAttribute("open", "true"), searchDrawer.querySelector("summary")?.setAttribute("aria-expanded", "true"), document.body.classList.add("overflow-hidden", "search-open"), document.querySelector(".template-index .header-wrapper")?.classList.remove("transparent-header");
                            const searchInput = searchDrawer.querySelector(".search__input.field__input");
                            searchInput && (searchInput.focus(), searchInput.click())
                        })
                    })
                }(), document.addEventListener("click", function(e) {
                    if (!(e.target.closest(".search-modal__close-button") || e.target.closest('button[aria-label="Close"]'))) return;
                    document.body.classList.remove("search-open", "overflow-hidden");
                    const searchDetails = document.querySelector(".header__search details[open]");
                    searchDetails && searchDetails.removeAttribute("open"), window.scrollY < 10 && document.querySelector(".template-index .header-wrapper")?.classList.add("transparent-header")
                })
  // customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
